<div class="w-full max-w-lg rounded-2xl bg-white p-5 shadow-xl sm:p-6">
  <div class="flex items-start justify-between gap-4">
    <div class="min-w-0">
      <h2 class="text-lg font-semibold text-slate-950">{{ title }}</h2>
      <p class="mt-2 text-sm leading-6 text-slate-600">
        This will permanently delete “{{ variableName }}”. This cannot be undone.
      </p>
    </div>
    <button
      type="button"
      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-lg text-slate-500 transition hover:bg-slate-100"
      aria-label="Close"
      (click)="close()">
      ×
    </button>
  </div>

  @if (usagesState.loading()) {
    <div
      class="mt-4 flex items-center gap-3 rounded-2xl bg-slate-100 px-4 py-3.5 text-sm text-slate-500">
      Loading usage…
    </div>
  } @else if (hasUsages()) {
    <div
      class="mt-4 flex items-center gap-3 rounded-2xl bg-slate-100 px-4 py-3.5">
      <div
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-600">
        <app-svg-icon src="assets/icons/chart-bar.svg" [size]="18" />
      </div>
      <div class="min-w-0 flex-1">
        <p class="text-sm font-semibold text-slate-900">
          {{ usageSummary() }}
        </p>
        <p class="mt-0.5 text-sm text-slate-500">
          View where it’s used before deleting.
        </p>
      </div>
      <button
        type="button"
        class="shrink-0 rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-sm font-medium text-blue-600 transition hover:border-slate-400 hover:bg-slate-50"
        (click)="openUsageOverlay()">
        Show usage
      </button>
    </div>
  } @else if (usagesReady()) {
    <div
      class="mt-4 flex items-center gap-3 rounded-2xl bg-slate-100 px-4 py-3.5">
      <div
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-600">
        <app-svg-icon src="assets/icons/chart-bar.svg" [size]="18" />
      </div>
      <div class="min-w-0 flex-1">
        <p class="text-sm font-semibold text-slate-900">
          Not used in any forms
        </p>
        <p class="mt-0.5 text-sm text-slate-500">
          Safe to delete with no linked field defaults.
        </p>
      </div>
    </div>
  }

  @if (hasUsages()) {
    <div class="mt-5">
      <p class="text-sm font-medium text-slate-900">
        What should happen to linked field defaults?
      </p>
      <div class="mt-3 flex flex-col gap-4">
        <div>
          <lib-signal-radio
            label="Retain value"
            groupName="delete-variable-mode"
            [optionValue]="DeleteDataLibraryVariableMode.retain"
            [value]="mode()"
            (valueChange)="setMode($event)" />
          <p class="mt-1 pl-7 text-sm leading-5 text-slate-500">
            Keep the current value as a static default on linked fields.
          </p>
        </div>
        <div>
          <lib-signal-radio
            label="Remove value"
            groupName="delete-variable-mode"
            [optionValue]="DeleteDataLibraryVariableMode.remove"
            [value]="mode()"
            (valueChange)="setMode($event)" />
          <p class="mt-1 pl-7 text-sm leading-5 text-slate-500">
            Clear the default on linked fields.
          </p>
        </div>
      </div>
    </div>
  }

  <div class="mt-5 border-t border-slate-200 pt-5">
    <lib-signal-text-field
      label="Type “delete” to confirm"
      placeholder="delete"
      [value]="confirmInput()"
      [debounceValueChange]="false"
      (valueChange)="confirmInput.set($event)" />
  </div>

  <div class="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
    <lib-signal-button
      appearance="outline"
      [fullWidth]="false"
      [disabled]="deleteState.loading()"
      (clicked)="close()">
      Cancel
    </lib-signal-button>
    <button
      type="button"
      class="inline-flex h-10 cursor-pointer items-center justify-center rounded-lg px-5 text-sm font-medium transition focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-red-100 disabled:cursor-not-allowed disabled:bg-slate-200 disabled:text-slate-400"
      [class.bg-red-600]="canDelete() && !deleteState.loading()"
      [class.text-white]="canDelete() && !deleteState.loading()"
      [class.hover:bg-red-700]="canDelete() && !deleteState.loading()"
      [disabled]="!canDelete() || deleteState.loading()"
      (click)="onDelete()">
      @if (deleteState.loading()) {
        Deleting…
      } @else {
        Delete variable
      }
    </button>
  </div>
</div>
